<template>
  <div class="nuttrema-table">
    <div class="nuttrema-table__header">
      <div class="nuttrema-table__header__row">
        <slot name="header"></slot>
      </div>
    </div>
    <div class="nuttrema-table__body">
      <slot name="body"></slot>
    </div>
  </div>
</template>


<script>
export default {
  name: 'nuttrema-table',
};
</script>

<style lang="scss" scoped>
  @import '~assets/styles/mixins/animation';

  @include color-change(#ffc107, #fff);

  .blink {
    animation: color-change 2s;
    -webkit-animation: color-change 2s;
  }

  .nuttrema-table {
    flex-grow: 1;
    display: flex;
    align-self: stretch;
    flex-direction: column;

    .nuttrema-table__header {
      flex-grow: 1;
      display: flex;
      align-self: stretch;

      .nuttrema-table__header__row {
        display: flex;
        flex-flow: row nowrap;
        background-color: #fff;
        justify-content: space-between;
        border-bottom: 1px solid #eeeeee;
        flex-grow: 1;
        flex-shrink: 0;
      }
    }

    .nuttrema-table__body {
      flex-grow: 1;
      display: flex;
      align-self: stretch;
      margin-bottom: 1.5em;
      flex-direction: column;
      background-color: #fff;
      align-content: flex-start;

      flex-shrink: 0;
      overflow: hidden;
      position: relative;

      .nuttrema-table__body__row {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;
        padding: 0.5em 0;
        border-bottom: 1px solid #eeeeee;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/ui/table/nuttrema-table.vue